import { Component } from '@angular/core';
import { SelectOption } from '../../../shared-components/custom-select/custom-select.component';

@Component({
	selector: 'app-readonly',
	templateUrl: './readonly.component.html',
	styleUrls: ['./readonly.component.scss'],
	standalone: false,
})
export class ReadonlyComponent {
	options: SelectOption[] = [
		{ label: 'Google', value: 'google' },
		{ label: 'Apple', value: 'apple' },
		{ label: 'Microsoft', value: 'microsoft' },
		{ label: 'Amazon', value: 'amazon', disabled: true },
		{ label: 'Meta', value: 'meta' },
		{ label: 'Netflix', value: 'netflix' },
		{ label: 'Tesla', value: 'tesla' },
		{ label: 'IBM', value: 'ibm' },
		{ label: 'Salesforce', value: 'salesforce', disabled: true },
		{ label: 'Adobe', value: 'adobe' },
		{ label: 'Mercedes', value: 'mercedes' },
	];

	inputValue: string = 'Input value';
	onInputChange(value: string): void {
		this.inputValue = value;
	}

	selectedValue: any = ['google', 'apple'];
	onSelectionChange(value: any): void {
		this.selectedValue = value;
	}

	checkboxValue: boolean = false;
	onCheckboxChange(value: boolean): void {
		this.checkboxValue = value;
	}
}
